export const algoliaFeatureAdapter = ({
  title,
  description,
  icon,
  link,
  tag,
}) => {
  return {
    logo: icon ? { alt: title, media: { url: icon } } : null,
    label: tag,
    title,
    description: description || null,
    link: {
      href: link,
    },
  }
}

export const algoliaFeaturesAdapter = (features) => {
  return features.map((feature) =>
    algoliaFeatureAdapter(feature)
  )
}
